import {
  ERROR_ACTION,
  GET_PAST_VISITS_SUCCESS,
  GET_PRODUCTS,
  GET_PRODUCTS_ERROR,
  GET_PRODUCTS_SUCCESS,
  GET_VISIT_SUCCESS,
  LOADING_ACTION,
  ORDER_PRODUCTS_SUCCESS,
} from './productsConstants'
import {
  getPatientPastVisitEndpoint,
  getProductsEndpoint,
  getVisitInfoEndpoint,
  processVisitPrescriptionEndpoint,
  methods,
} from '../../utils/apiHelper'
import { apiCall } from '../../utils/restclient'
import { type OrderInfo } from '../../types/products/productTypes'

export const getProducts = (patientId: string, category: string, tabId: string, usState?: string) => {
  const endpoint = getProductsEndpoint(category, usState, patientId)
  const action = {
    type: GET_PRODUCTS,
    extraData: { patientId, tabId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.GET, null, null, {
      success: GET_PRODUCTS_SUCCESS,
      error: GET_PRODUCTS_ERROR,
      extraData: { patientId, tabId, usState, category },
    })
    return action
  } catch (e) {
    console.log(e)
  }
  return action
}

export const orderProduct = (patientId: string, visitId: string | undefined, tabId: string, option: OrderInfo) => {
  const endpoint = processVisitPrescriptionEndpoint(visitId)

  const action = {
    type: LOADING_ACTION,
    extraData: { patientId, visitId, tabId, option },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.POST, null, JSON.stringify(option), {
      success: ORDER_PRODUCTS_SUCCESS,
      error: ERROR_ACTION,
      extraData: { patientId, tabId, visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getPastVisitsForProduct(patientId) {
  const endpoint = getPatientPastVisitEndpoint(patientId)
  const action = {
    type: LOADING_ACTION,
    extraData: { patientId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PAST_VISITS_SUCCESS,
      error: ERROR_ACTION,
      extraData: { patientId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getVisitInfoForProduct(visitId) {
  const endpoint = getVisitInfoEndpoint(visitId)
  const action = {
    type: LOADING_ACTION,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_VISIT_SUCCESS,
      error: ERROR_ACTION,
      extraData: { visitId },
    })
    return action
  } catch (e) {
    console.error(e)
  }
}
